import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.companies.length > 0)?_c(VSelect,{attrs:{"items":_vm.companies,"label":"Switch Company","item-text":"name","item-value":"emis"},on:{"change":function($event){return _vm.getSelectedCompany()}},model:{value:(_vm.selectedCompanyEmis),callback:function ($$v) {_vm.selectedCompanyEmis=$$v},expression:"selectedCompanyEmis"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }